import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';

type AccountActionsProps = {
  handleSubmit(): void;
};

const AccountActions: React.FC<AccountActionsProps> = ({ handleSubmit }) => {
  return (
    <Tooltip title="Salvar">
      <IconButton color="inherit" onClick={handleSubmit}>
        <DoneIcon />
      </IconButton>
    </Tooltip>
  );
};

export default AccountActions;
